<script>
import CrudListVue from '@/app/arch/components/crud/CrudList.vue';
import NotificationsRequest from 'Modules/contacard/communication/notifications/NotificationRequest';
import DataTableDateColumnVue from '@/app/arch/components/data-table/DataTableColumns/DataTableDateColumn.vue';
import NotificationStatusColumnVue from 'Modules/contacard/communication/notifications/components/columns/NotificationStatusColumn.vue';
import HistoryStatusNotificationColumnVue from 'Modules/contacard/communication/notifications/components/columns/HistoryStatusNotificationColumn.vue';

export default {
  name: 'NotificationsCrudList',
  extends: CrudListVue,
  data: (vm) => ({
    requestClass: NotificationsRequest,
    editRoute: 'historyNotification.edit',
    headers: [
      {
        text: 'Código',
        value: 'id',
      },
      {
        text: 'Título',
        value: 'title',
      },
      {
        text: 'Descrição',
        value: 'description',
        tooltip: true,
      },
      {
        text: 'Status',
        value: 'status',
        component: NotificationStatusColumnVue,
      },
      {
        text: 'Criador',
        value: 'createdByName',
      },
      {
        text: 'Usuários selecionados',
        value: 'userList',
        handler: vm.getUsersLength,
      },
      {
        text: 'SMS',
        value: 'sendSms',
        component: HistoryStatusNotificationColumnVue,
      },
      {
        text: 'E-mail',
        value: 'sendEmail',
        component: HistoryStatusNotificationColumnVue,
      },
      {
        text: 'Push',
        value: 'sendPush',
        component: HistoryStatusNotificationColumnVue,
      },
      {
        text: 'Data da criação',
        value: 'createdAt',
        component: DataTableDateColumnVue,
      },
      {
        text: 'Data de envio',
        value: 'scheduledDate',
        component: DataTableDateColumnVue,
      },
    ],
  }),
  methods: {
    getUsersLength(users) {
      if (users) {
        if (typeof users === 'string') {
          try {
            const arrUsers = JSON.parse(users);

            return arrUsers.length;
          } catch (err) {
            return users.length;
          }
        }
        return users.length;
      }
      return 0;
    },
    prepareRequest(params) {
      return this.requestClass.list(
        this.makeDefaultParams(params),
      );
    },
    makeDefaultParams(params = {}) {
      return {
        Status: '2,3,4',
        ...params,
      };
    },
  },
};
</script>
